var map = {
	"./24h_trade_volume.png": "./src/assets/images/24h_trade_volume.png",
	"./Arbitrum_HorizontalLogo-dark.svg": "./src/assets/images/Arbitrum_HorizontalLogo-dark.svg",
	"./Arbitrum_HorizontalLogo.svg": "./src/assets/images/Arbitrum_HorizontalLogo.svg",
	"./Farm.svg": "./src/assets/images/Farm.svg",
	"./KNC.svg": "./src/assets/images/KNC.svg",
	"./KNCL.png": "./src/assets/images/KNCL.png",
	"./about_background.png": "./src/assets/images/about_background.png",
	"./alert.svg": "./src/assets/images/alert.svg",
	"./arrow-right.svg": "./src/assets/images/arrow-right.svg",
	"./big_unicorn.png": "./src/assets/images/big_unicorn.png",
	"./blue-loader.svg": "./src/assets/images/blue-loader.svg",
	"./bnb-logo.png": "./src/assets/images/bnb-logo.png",
	"./btt-logo-dark.svg": "./src/assets/images/btt-logo-dark.svg",
	"./btt-logo.svg": "./src/assets/images/btt-logo.svg",
	"./coinbaseWalletIcon.svg": "./src/assets/images/coinbaseWalletIcon.svg",
	"./dropdown.svg": "./src/assets/images/dropdown.svg",
	"./enter 1.svg": "./src/assets/images/enter 1.svg",
	"./ethereum-logo.png": "./src/assets/images/ethereum-logo.png",
	"./flag-EN.svg": "./src/assets/images/flag-EN.svg",
	"./flag-KO.svg": "./src/assets/images/flag-KO.svg",
	"./flag-TR.svg": "./src/assets/images/flag-TR.svg",
	"./flag-VI.svg": "./src/assets/images/flag-VI.svg",
	"./flag-ZH.svg": "./src/assets/images/flag-ZH.svg",
	"./fortmaticIcon.png": "./src/assets/images/fortmaticIcon.png",
	"./ledger.svg": "./src/assets/images/ledger.svg",
	"./light-ledger.svg": "./src/assets/images/light-ledger.svg",
	"./light-metamask.svg": "./src/assets/images/light-metamask.svg",
	"./light-trezor.svg": "./src/assets/images/light-trezor.svg",
	"./light-wallet-connect.svg": "./src/assets/images/light-wallet-connect.svg",
	"./light-wallet-link.svg": "./src/assets/images/light-wallet-link.svg",
	"./menu.svg": "./src/assets/images/menu.svg",
	"./metamask.png": "./src/assets/images/metamask.png",
	"./metamask.svg": "./src/assets/images/metamask.svg",
	"./noise.png": "./src/assets/images/noise.png",
	"./portisIcon.png": "./src/assets/images/portisIcon.png",
	"./rain-maker-mobile.png": "./src/assets/images/rain-maker-mobile.png",
	"./rain-maker.png": "./src/assets/images/rain-maker.png",
	"./signal_cellular_alt_black_24dp 3.svg": "./src/assets/images/signal_cellular_alt_black_24dp 3.svg",
	"./trending_hero_laptop.png": "./src/assets/images/trending_hero_laptop.png",
	"./trending_hero_mobile.png": "./src/assets/images/trending_hero_mobile.png",
	"./trending_hero_tablet.png": "./src/assets/images/trending_hero_tablet.png",
	"./trending_soon_hero_laptop.png": "./src/assets/images/trending_soon_hero_laptop.png",
	"./trending_soon_hero_mobile.png": "./src/assets/images/trending_soon_hero_mobile.png",
	"./trending_soon_hero_tablet.png": "./src/assets/images/trending_soon_hero_tablet.png",
	"./trezor.svg": "./src/assets/images/trezor.svg",
	"./trustWallet.png": "./src/assets/images/trustWallet.png",
	"./wallet-connect.svg": "./src/assets/images/wallet-connect.svg",
	"./wallet-link.svg": "./src/assets/images/wallet-link.svg",
	"./walletConnectIcon.svg": "./src/assets/images/walletConnectIcon.svg",
	"./x.svg": "./src/assets/images/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";